
    <ng-template>
      <ng-content></ng-content>
    </ng-template>